import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesLeft,
  faAnglesRight,
  faAreaChart,
  faCartShopping,
  faClipboard,
  faCog,
  faExchange,
  faGift,
  faPaperPlane,
  faShop,
  faTasks,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "../styles/Sidebar.css";
import $ from "jquery";
import { faProductHunt } from "@fortawesome/free-brands-svg-icons";

$(function () {
  // toggle sidebar collapse
  $(".btn-toggle-sidebar").on("click", function () {
    $(".wrapper").toggleClass("sidebar-collapse");
  });
  // mark sidebar item as active when clicked
  $(".sb-item").on("click", function () {
    if ($(".wrapper").hasClass("sidebar-collapse")) {
      $("aside.ant-layout-sider.ant-layout-sider-dark").attr(
        "style",
        "min-width: 50px !important"
      );
    } else {
      $("aside.ant-layout-sider.ant-layout-sider-dark").attr(
        "style",
        "min-width: 170px !important"
      );
    }

    if ($(this).hasClass("btn-toggle-sidebar")) {
      return; // already actived
    }

    $(this).siblings().removeClass("active");
    $(this).siblings().find(".sb-item").removeClass("active");
    $(this).addClass("active");
  });
});

const Sidebar = ({ roldeId }) => {
  let navigate = useNavigate();

  const routeChange = (path) => {
    navigate(path);
  };

  return (
    <div className="wrapper">
      <div className="sidebar">
        <div className="sb-item-list">
          <div
            className="sb-item"
            onClick={(e) => {
              routeChange("/");
            }}
          >
            <FontAwesomeIcon icon={faAreaChart} />
            <span className="sb-text">Dashboard</span>
          </div>
          <div
            className="sb-item"
            onClick={(e) => {
              routeChange("/orders");
            }}
          >
            <FontAwesomeIcon icon={faCartShopping} />
            <span className="sb-text">Orders</span>
          </div>
          <div
            className="sb-item"
            onClick={(e) => {
              routeChange("/transcations");
            }}
          >
            <FontAwesomeIcon icon={faExchange} />
            <span className="sb-text">Transcations</span>
          </div>
          {roldeId === "1" && (
            <>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/create-custom-order");
                }}
              >
                <FontAwesomeIcon icon={faGift} />
                <span className="sb-text">Custom Orders</span>
              </div>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/shops");
                }}
              >
                <FontAwesomeIcon icon={faShop} />
                <span className="sb-text">Shops</span>
              </div>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/products");
                }}
              >
                <FontAwesomeIcon icon={faProductHunt} />
                <span className="sb-text">Products</span>
              </div>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/category");
                }}
              >
                <FontAwesomeIcon icon={faClipboard} />
                <span className="sb-text">Categories</span>
              </div>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/variants");
                }}
              >
                <FontAwesomeIcon icon={faTasks} />
                <span className="sb-text">Variants</span>
              </div>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/attributes");
                }}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
                <span className="sb-text">Attributes</span>
              </div>
              <div
                className="sb-item"
                onClick={(e) => {
                  routeChange("/settings");
                }}
              >
                <FontAwesomeIcon icon={faCog} />
                <span className="sb-text">Settings</span>
              </div>
            </>
          )}
          <div className="btn-toggle-sidebar sb-item">
            <FontAwesomeIcon icon={faAnglesLeft} />
            <span className="sb-text">Collapse Sidebar</span>
            <FontAwesomeIcon icon={faAnglesRight} />
          </div>
        </div>
      </div>
      <div className="main"></div>
    </div>
  );
};

export default Sidebar;
